import { TableCell, TableRow, Typography } from '@mui/material';
import { useCallback, useMemo, useState } from 'react';
import { RejectHistory } from 'components/dialog/RejectHistory';
import { DateObject } from 'react-multi-date-picker';

export const ConductorRow = ({ row, index }) => {
  const [openRejectHistory, setOpenRejectHistory] = useState(false);

  const headers = useMemo(() => {
    const headerArray = [];

    const date = new DateObject();
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < 14; i++) {
      const dateText = `${date.format('YYYY-MM-DD')}`;
      headerArray.push(dateText);
      date.add(1, 'day');
    }
    return headerArray;
  }, []);

  const renderCell = useCallback(
    (headerDate) => {
      if (row?.data?.length === 0) return '-';
      const evnets = row?.data?.map((webinarItem) => {
        const rowDate = new DateObject(webinarItem?.liveAt).format('YYYY-MM-DD');
        if (rowDate === headerDate) {
          return webinarItem?._id?.split('_')[0];
        }
        return undefined;
      });

      const result = evnets
        ?.filter((e) => e !== undefined)
        ?.map((ev, index) => (
          <Typography key={index} color={'#0A0C0F'} fontWeight={700}>
            {ev}
          </Typography>
        ));

      if (result?.length === 0) return '-';

      return result;
    },
    [row]
  );

  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="center">
          <Typography fontWeight={700}>{row?.hour}</Typography>
        </TableCell>
        {headers?.map((headerDate, i) => (
          <TableCell key={i} align="center">
            {renderCell(headerDate)}
          </TableCell>
        ))}
      </TableRow>
      <RejectHistory
        open={openRejectHistory}
        onClose={() => setOpenRejectHistory(false)}
        content={row?.status === 3 ? row?.activation : row?.deactivation}
        status={row?.status}
      />
    </>
  );
};
